import { BackgroundColor } from "../../background/constants/background-types";
import { CheckboxSchemeDefinition } from "./checkbox-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createCheckboxMapDefinition } from "../../../utils/scheme-helper";

function createSchemes() {
  let newSchemes: AllColors.CheckboxSchemeConfiguration<CheckboxSchemeDefinition> = {};
  AllColors.CHECKBOX_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      labelColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      labelColorDisabled: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_60`],
      errorColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_2`],
      outlineColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_2`],
      outlineColorSelected: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_2`],
      borderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      borderColorHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      borderColorFocus: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      borderColorDisabled: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_50`],
      borderColorSelected: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      borderolorSelectedHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      borderColorSelectedFocus: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      borderColorSelectedDisabled: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_50`],
      backgroundColor: "transparent",
      backgroundColorHover: "transparent",
      backgroundColorFocus: "transparent",
      backgroundColorDisabled: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_50`],
      backgroundColorSelected: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      backgroundColorSelectedHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_2`],
      backgroundColorSelectedFocus: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_2`],
      backgroundColorSelectedDisabled: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_50`],
      iconColor: "transparent",
      iconColorHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      iconColorFocus: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      iconColorDisabled: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      iconColorSelected: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      iconColorSelectedHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      iconColorSelectedFocus: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      iconColorSelectedDisabled: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const CHECKBOX_SCHEME_CONFIG: AllColors.CheckboxSchemeConfiguration<CheckboxSchemeDefinition> = createSchemes();

export const CHECKBOX_SCHEME_MAP: Map<BackgroundColor | "default", CheckboxSchemeDefinition> = new Map(
  Object.entries(createCheckboxMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    CHECKBOX_SCHEME_CONFIG[config as string]
  ])
);
